__turbopack_context__.v({
  "shareButton": "styles-module__DV02zG__shareButton",
  "shareIcons": "styles-module__DV02zG__shareIcons",
});
